<template>
    <div class="navigation">
        <div class="logo" @click="goHome">
            <div class="pt title1">东北师范大学</div>
            <div class="nav-line"></div>
            <div class="pt title2">文学院</div>
        </div>
         
        <div
            
            class="list pt "
            :class="[currentRoute == item.path || selected === index ? 'hover-line' : '']"
            v-for="(item, index) in list"
            :key="item.name"
            @click="jump(item)"
            @mouseover="mouseOver(index, item)"
            @mouseout="mouseOut(index, item)"
        >
            <el-popover
                class="popover"
                placement="bottom-start"
                width="50"
                trigger="hover">
                <div 
                    class="child"
                >
                    <div
                        class="child-item"
                        v-for="item2 in item.children"
                        :key="item2.name"
                        @click.stop="jumpSecond(item, item2)"
                    >{{item2.name}}</div>
                </div>
                <div slot="reference">{{item.name}}</div>
            </el-popover>
        </div>
        
        <div class="search" :class="[isShowSearch ? 'show' : '']">
            <input 
                class="search-input" 
                v-model="searchValue" 
                type="text" 
                placeholder="您想寻找内容的文字"
                autofocus
                @keydown.enter="jumpSearch"
            >
            <div 
                class="search-button" 
                @click="jumpSearch"
                @mouseover="overSearchBtn"
            >寻</div>
        </div>
    </div>
</template>

<script  type="text/javascript">
// import Bus from '@/bus.js'
export default {
    name: "navBar",
    data() {
        return{
            searchValue: '',
            currentRoute: '',
            list: [{
                name: "学院概况",
                path: 'college',
                children: [{
                    name: '学院简介',
                    id: 0
                }, {
                    name: '历史沿革',
                    id: 1
                }, {
                    name: '知名学者',
                    id: 2
                }, {
                    name: '领导团队',
                    id: 3
                }, {
                    name: '组织机构',
                    id: 4
                }]
            }, {
                name: "人才培养",
                path: 'talents',
                children: [{
                    name: '本科生教育',
                    id: 0
                }, {
                    name: '研究生教育',
                    id: 1
                }, {
                    name: '博士后流动站',
                    id: 2
                }, {
                    name: '教学成果',
                    id: 3
                }]
            }, {
                name: "师资力量",
                path: 'staff',
                children: [{
                    name: '专任教师',
                    id: 0
                }, {
                    name: '行政教辅',
                    id: 1
                }, {
                    name: '外聘教师',
                    id: 2
                }]
            }, {
                name: "学术研究",
                path: 'science',
                children: [{
                    name: '学科方向',
                    id: 0
                }, {
                    name: '学术活动',
                    id: 1
                }, {
                    name: '学术成果',
                    id: 2
                }, {
                    name: '学术刊物',
                    id: 3
                }]
            }, {
                name: "党建园地",
                path: 'party',
                children: [{
                    name: '党群组织',
                    id: 0
                }, {
                    name: '党建制度',
                    id: 1
                }, {
                    name: '党建活动',
                    id: 2
                }, {
                    name: '学习资料',
                    id: 3
                }]
            }, {
                name: "学生工作",
                path: 'student',
                children: [{
                    name: '学工制度',
                    id: 0
                }, {
                    name: '学生活动',
                    id: 1
                }]
            }],
            selected: '',
            isShowSearch: false,
            children: []
        }
    },
    watch: {
        '$route'() {
            this.refreshRoute()
            this.isShowSearch = false
        }
    },
    methods: {
        mouseOver(index, item) {
            this.children = item.children
            item.show = true
            this.selected = index
            this.currentRoute = ''
        },
        mouseOut(index, item) {
            item.show = false
            this.selected = ''
            this.refreshRoute()
        },
        jump(item) {
            this.$router.push({
                name: item.path
            })
            this.refreshRoute()
        },
        jumpSecond(item, item2) {
            this.$router.push({
                name: item.path,
                params: {
                    id: item2.id
                }
            })
            this.refreshRoute()
        },
        refreshRoute() {
            // this.isShowSearch = this.$route.name == 'search'
            if (this.selected !== '') {
                this.currentRoute = ''
                return
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.currentRoute = this.$route.name
                    
                }, 10)
            })
        },
        overSearchBtn() {
            this.isShowSearch = true
        },
        goHome() {
            this.$router.push({
                name: 'home'
            })
        },
        jumpSearch() {
            console.log(this.searchValue)
            this.isShowSearch = false
            
            if (this.$route.name != 'search') {
                this.$router.push({
                    name: 'search'
                })
            }
            
            this.$store.commit('setSearch', this.searchValue)
            this.searchValue = ''

        }
    },
    mounted() {
        this.refreshRoute()
    }
}
</script>
<style lang="less">
    .search{
        position: absolute;
        right: 10%;
        top: 60px;
        display: flex;
        &-button{
            color: #1E00A0;
            font-size: 1.8rem;
            // font-size: 18px;
            height: 30px;
            width: 36px;
            text-align: center;
            line-height: 30px;
            border-right: 1px solid #1E00A0;
            border-left: 1px solid #1E00A0;
            cursor: pointer;
        }
        &-input{
            padding-left: 12px;
            color: #231815;
            font-size: 1.4rem;
            width: 0;
            border: none;
            outline: none;
            transition: all 0.2s linear;
        }
        &.show{
            border-left: 1px solid #1E00A0;
            .search-button{
                border-left: none;
            }
            .search-input{
                width: 200px;
            }
        }
    }
    .list{
        font-size: 1.8rem;
        width: 20px;
        line-height: 25px;
        margin-right: 50px;
        cursor: pointer;
        position: relative;
        align-self: flex-start;
        &.hover-line:after{
            content: '';
            position: absolute;
            left: -10px;
            top: 0;
            height: 145px;
            // border-left: 1px solid #c4c4c4;
            transition: all 0.2s linear;
        }
        &:hover.hover-line:after{
            // height: 100%;
        }
        &:hover{
            .child{
                // display: block;
            }
        }
        // &:hover:after{
        //     content: '';
        //     position: absolute;
        //     left: -10px;
        //     top: 0;
        //     height: 145px;
        //     border-left: 1px solid #c4c4c4;
        //     transition: all 0.2s linear;
        // }
    }
    .el-popover{
        padding: 8px !important;
        margin-left: -10px;
    }
    .popover{
        min-width: 120px;
        padding: 0;
    }
    .child{
        // margin-top: 20px;
        // min-width: 120px;
        // font-size: 1.4rem;
        // color: #787878;
        // letter-spacing: 2px;
        // transition: all 0.2s linear;
        // position: relative;
        // z-index: 200;
        // background: white;
        // border-radius: 2px;
        // box-shadow: 0 0 10px 4px rgba(0,0,0,.1);
        // padding: 10px;
        // margin-left: -20px;
        padding-top: 10px;
        &:after{
            // content: "";
            // position: absolute;
            // left: 22px;
            // top: -6px;
            // border-bottom: 6px solid white;
            // border-left: 6px solid transparent;
            // border-right: 6px solid transparent;
        }
        &-item{
            padding-bottom: 8px;
            white-space: nowrap;
            font-family: DemiLightff;
            padding-left: 10px;
            cursor: pointer;
            &:hover{
                color: #1E009B;
            }
        }
    }



    .pt{
        padding-top: 50px;
    }
    .navigation{
        margin: -60px auto 0;
        min-width: 600px;
        width: 70%;
        height: 234px;
        display: flex;
        color: #1E009B;
        position: relative;
        .logo{
            display: flex;
            margin-right: 10%;
            cursor: pointer;
        }
    }
    .title1{
        width: 22px;
        font-size: 1.8rem;
        line-height: 24px;
    }
    .title2{
        width: 30px;
        font-size: 3rem;
        line-height: 54px;
        margin-top: -10px;
        
    }
    .nav-line{
        height: 196px;
        border-right: 1px solid #1E009B;
        margin: 0 16px;
    }
</style>